import { ColDef, ColGroupDef, ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';
import { getMantyStatusColumn } from 'routes/HumanResourcesModule/PayState/helpers/colDefinitions';
import { DetailedEnvelopeMantyStatusHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/helpers/types';
import { envelopeMantyStatusHypothesisValueGetter } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Resume/NonRecurrentEnvelopesResume/helpers/mantyStatusHypothesisHelpers';
import { ENVELOPE_MANTY_STATUS_HYPOTHESIS } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/helpers/constants';
import {
    isRowGrouped,
    isRowPinned,
} from 'routes/HumanResourcesModule/Simulation/helpers/gridHelpers';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import {
    ORG_CHART_HR_MAPPING,
    ORG_CHART_HR_NAME,
} from 'routes/HumanResourcesModule/business/definitions';
import { TEXT_FILTER } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';

const envelopeMantyStatusHypothesisCellRendererSelector = (
    params: ICellRendererParams,
) => {
    if (isRowGrouped(params)) return { component: 'agGroupCellRenderer' };
    if (isRowPinned(params)) return { component: undefined };
    return {
        component: 'editEnvelopeMantyStatusHypothesisCellRenderer',
    };
};
export const getColDefs = ({
    hrSimulation,
    envelopeMantyStatusHypotheses,
}: {
    hrSimulation: HrSimulation;
    envelopeMantyStatusHypotheses: DetailedEnvelopeMantyStatusHypothesis[];
}): (ColDef | ColGroupDef)[] => {
    const columns = [
        {
            ...TEXT_FILTER,
            headerName: t(`humanResources.simulation.${ORG_CHART_HR_MAPPING}`),
            field: ORG_CHART_HR_NAME,
            enableRowGroup: false,
        },
        {
            ...getMantyStatusColumn(),
            enableRowGroup: true,
        },
        {
            ...TEXT_FILTER,
            headerName: t('humanResources.simulation.hypothesis'),
            field: ENVELOPE_MANTY_STATUS_HYPOTHESIS,
            cellRendererSelector:
                envelopeMantyStatusHypothesisCellRendererSelector,
            valueGetter: envelopeMantyStatusHypothesisValueGetter(
                envelopeMantyStatusHypotheses,
            ),
            filterValueGetter: () => {
                return t('humanResources.simulation.editHypothesis');
            },
            cellRendererParams: {
                hrSimulation,
                isUpdateEnabled: false,
            },
        },
    ];
    return columns;
};
